import { defineEvent } from '@itc/shared';
import { z } from 'zod';

// Donations' events (plan 2C Approach). Each is published in the same commit as
// the change it follows, and Donations' own handlers make the cross-module calls
// (ADR 0013). `DonationAccepted` is for 2D and Shipyards to subscribe to as well.

/** A donation was accepted: its deposit or stock follows (settlement.ts). */
export const DonationAccepted = defineEvent({
  type: 'donations.accepted',
  data: z.object({ donationId: z.string(), kind: z.enum(['auec', 'items']), acceptedBy: z.string() }),
});

/** An accepted donation was reversed: its deposit or stock is undone. */
export const DonationReversed = defineEvent({
  type: 'donations.reversed',
  data: z.object({ donationId: z.string(), reversedBy: z.string() }),
});

/** An expected delivery was received: the stock handler stocks it. */
export const DeliveryReceived = defineEvent({
  type: 'donations.delivery_received',
  data: z.object({ deliveryId: z.string(), receivedBy: z.string() }),
});

/** A receiver asked to retry a failed settlement, with the same key, so nothing done is done twice. */
export const SettleRequested = defineEvent({
  type: 'donations.settle_requested',
  data: z.object({ donationId: z.string().optional(), deliveryId: z.string().optional(), phase: z.enum(['settle', 'undo']) }),
});
